import { ArrayValues, ValueOf } from 'type-fest';

const contentStatuses = [
  { label: 'Published', color: '#07D034', value: 1 },
  { label: 'Draft', color: '#FF8D23', value: 0 },
] as const;

export type ContentStatus = ValueOf<
  ArrayValues<typeof contentStatuses>,
  'value'
>;

export default contentStatuses;
